import Service from './svgs/Service';
import Fulfillment from './svgs/Fulfillment';
import HandyMan from './svgs/HandyMan';
import { FULFILLMENT_ORDERS_ROUTE } from '../../pages/fulfillment/FulfillmentOrdersList';
import { BIKE_QC_ROUTE } from '../../pages/fulfillment/BikeQcList';
import { WAVES_LIST_ROUTE } from '../../pages/fulfillment/WavesList';
import { LPU_QUEUE_ROUTE } from '../../pages/fulfillment/LpuQueue';
import { REVIEW_QUEUE_ROUTE } from '../../pages/fulfillment/ReviewQueue';
import { LPU_PICKUP_LIST_ROUTE } from '../../pages/retail/LpuPickupOrdersList';
import TradeUps from './svgs/TradeUps';
import ItemCatalog from './svgs/ItemCatalog';
import ThreeSixty from './svgs/ThreeSixty';
import Intake from './svgs/Intake';
import { TRADEUP_SEARCH_ROUTE } from '../../pages/tradeups/SubmissionListView';
import { CREATE_SUBMISSION_ON_BEHALF_ROUTE } from '../../pages/tradeups/CreateSubmissionOnBehalf';
import { DEALER_MANAGEMENT_ROUTE } from '../../pages/dealers/DealerVendorListView';
import { MULTI_ITEM_RELOCATOR_ROUTE } from '../../pages/inventory/relocate/MultiItemRelocator';
import { CREATE_INVENTORY_ADJUSTMENT_ROUTE } from '../../pages/inventory/adjustments/CreateInventoryAdjustment';
import { BIKE_PART_OUT_ROUTE } from '../../pages/inventory/adjustments/BikePartOut';
import InventoryManagement from './svgs/InventoryManagement';
import { Permissions } from '../../reducers/types';
import { INVENTORY_LOCATION_DETAILS_ROUTE } from '../../pages/inventory/relocate/InventoryLocationDetails';
import { INVENTORY_TRANSFERS_ROUTE } from '../../pages/inventory/transfers/InventoryTransfersList';
import { INVENTORY_ADJUSTMENTS_ROUTE } from '../../pages/inventory/adjustments/InventoryAdjustmentsList';
import { SINGLE_ITEM_RELOCATOR_ROUTE } from '../../pages/inventory/relocate/SingleItemRelocator';

interface SubNav {
  parent: string;
  name: string;
  to: string;
  restrict?: number;
  dividerAfter?: boolean;
}

interface NavItemObj {
  icon: any;
  to?: string;
  displayTitle?: string;
  subNav?: SubNav[];
  dividerAfter?: boolean;
}

interface NavItem {
  [key: string]: NavItemObj;
}

const navItems: NavItem = {
  fulfillment: {
    icon: Fulfillment,
    displayTitle: 'Fulfillment',
    subNav: [
      {
        parent: 'fulfillment',
        name: 'Orders',
        to: FULFILLMENT_ORDERS_ROUTE,
      },
      {
        parent: 'fulfillment',
        name: 'Bike QC',
        to: BIKE_QC_ROUTE,
      },
      {
        parent: 'fulfillment',
        name: 'Waves',
        to: WAVES_LIST_ROUTE,
      },
      {
        parent: 'fulfillment',
        name: 'Local Pickup',
        to: LPU_QUEUE_ROUTE,
      },
      {
        parent: 'fulfillment',
        name: 'Review Queue',
        to: REVIEW_QUEUE_ROUTE,
      },
    ],
  },
  retail: {
    icon: HandyMan,
    displayTitle: 'Retail',
    subNav: [
      {
        parent: 'retail',
        name: 'Local Pickup Orders',
        to: LPU_PICKUP_LIST_ROUTE,
      },
    ],
  },
  service: {
    icon: Service,
    subNav: [
      {
        parent: 'service',
        name: 'Cycle Timing',
        to: '/service/cycle-timings',
      },
      {
        parent: 'service',
        name: 'Service Plans',
        to: '/service/service-plans',
      },
      {
        parent: 'service',
        name: 'New Service Plan',
        to: '/service/submitNew',
      },
    ],
  },
  tradeups: {
    icon: TradeUps,
    subNav: [
      {
        parent: 'tradeups',
        name: 'Tradeups',
        to: TRADEUP_SEARCH_ROUTE,
      },
      {
        parent: 'tradeups',
        name: 'Create Submission',
        to: CREATE_SUBMISSION_ON_BEHALF_ROUTE,
        restrict: Permissions.CREATE_SUBMISSION_ON_BEHALF,
      },
      {
        parent: 'tradeups',
        name: 'Catch & Release',
        to: '/buyers/tradeups/catchrelease',
      },
      {
        parent: 'tradeups',
        name: 'Dealer Management',
        to: DEALER_MANAGEMENT_ROUTE,
        restrict: Permissions.ADMIN_DEALERS,
      },
      {
        parent: 'tradeups',
        name: 'Leads Online',
        to: '/leadsOnline',
      },
    ],
  },
  360: {
    icon: ThreeSixty,
    subNav: [
      {
        parent: '360',
        name: 'Product 360',
        to: '/products/360view',
      },
      {
        parent: '360',
        name: 'Customer 360',
        to: '/customer360',
      },
    ],
  },
  intake: {
    icon: Intake,
    subNav: [
      {
        parent: 'intake',
        name: 'Buyers',
        to: '/buyers',
      },
      {
        parent: 'intake',
        name: 'Create Barcode',
        to: '/products/createBarcode',
      },
      {
        parent: 'intake',
        name: 'Receiving',
        to: '/receiving',
      },
    ],
  },
  itemCatalog: {
    icon: ItemCatalog,
    displayTitle: 'Item Catalog',
    subNav: [
      {
        parent: 'item catalog',
        name: 'Add Product',
        to: '/catalog/product-creation',
      },
      {
        parent: 'item catalog',
        name: 'Search',
        to: '/catalog/products',
      },
      {
        parent: 'item catalog',
        name: 'UPC Search',
        to: '/catalog/upc',
      },
    ],
  },
  inventoryManagement: {
    icon: InventoryManagement,
    displayTitle: 'Inventory',
    dividerAfter: true,
    subNav: [
      {
        parent: 'inventory',
        name: 'Inventory Details',
        to: INVENTORY_LOCATION_DETAILS_ROUTE,
        dividerAfter: true,
      },
      {
        parent: 'inventory',
        name: 'Inventory Transfers',
        to: INVENTORY_TRANSFERS_ROUTE,
        restrict: Permissions.MANAGE_INVENTORY,
      },
      {
        parent: 'inventory',
        name: 'Single Item Relocate',
        to: SINGLE_ITEM_RELOCATOR_ROUTE,
      },
      {
        parent: 'inventory',
        name: 'Multi-Item Relocate',
        to: MULTI_ITEM_RELOCATOR_ROUTE,
        dividerAfter: true,
      },
      {
        parent: 'inventory',
        name: 'Inventory Adjustments',
        to: INVENTORY_ADJUSTMENTS_ROUTE,
        restrict: Permissions.MANAGE_INVENTORY,
      },
      {
        parent: 'inventory',
        name: 'Create Inventory Adjustment',
        to: CREATE_INVENTORY_ADJUSTMENT_ROUTE,
        restrict: Permissions.MANAGE_INVENTORY,
      },
      {
        parent: 'inventory',
        name: 'Bike Part-Out',
        to: BIKE_PART_OUT_ROUTE,
        restrict: Permissions.MANAGE_INVENTORY,
      },
    ],
  },
};

export default navItems;
